// Map URL slugs (the segment after /admin/) to backend resource `kind` values.
// Used by App.js to render the generic ResourceCRUDPage.
export const SLUG_TO_KIND = {
  // Voice
  "sip-trunks":      "sip_trunks",
  "dids":            "dids",
  "extensions":      "extensions",
  "recording-rules": "recording_rules",
  "caller-id-pool":  "caller_id_pool",
  "music-on-hold":   "music_on_hold",
  "audio-prompts":   "audio_prompts",
  "working-hours-profiles": "working_hours_profiles",
  // Routing
  "queues":          "queues",
  "ivr-flows":       "ivr_flows",
  "skills":          "skills",
  "skill-rules":     "skill_rules",
  "vip-rules":       "vip_rules",
  "voicemail":       "voicemail_boxes",
  "did-routes":      "did_routes",
  // Outbound
  "campaigns":         "campaigns",
  "lead-lists":        "lead_lists",
  "dnc-lists":         "dnc_lists",
  "compliance-rules":  "compliance_rules",
  "amd-settings":      "amd_settings",
  "voice-broadcast":   "broadcast_messages",
  // Omnichannel
  "webchat":           "webchat_widgets",
  "wa-templates":      "wa_templates",
  "email-signatures":  "email_signatures",
  "canned-responses":  "canned_responses",
  // Agent UI
  "agent-layouts":     "agent_layouts",
  // AI / Speech
  "llm-config":   "llm_configs",
  "stt-config":   "stt_configs",
  "kb":           "kb_documents",
  "ai-prompts":   "ai_prompts",
  "pii-rules":    "pii_rules",
  // QM
  "scorecards":    "scorecards",
  "qm-samples":    "qm_samples",
  "coaching":      "coaching_plans",
  "calibration":   "qm_calibrations",
  // Reporting
  "report-templates":  "report_templates",
  "report-schedules":  "report_schedules",
  "leaderboards":      "leaderboards",
  "kpi-dashboards":    "kpi_dashboards",
  // Integrations / API
  "webhooks":      "webhooks",
  "api-keys":      "api_keys",
  "crm-mappings":  "crm_mappings",
  // Ticketing
  "ticket-queues":     "ticket_queues",
  "ticket-categories": "ticket_categories",
  "sla-policies":      "sla_policies",
  // Security
  "retention":     "retention_policies",
  "ip-allowlist":  "ip_allowlists",
  "consent":       "consent_templates",
  // Operator
  "rate-plans":    "rate_plans",
};
